// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"bc4ff6d4","401":"2815a86a"}[chunkId] + ".chunk.css";
};